var _defs, _path, _path2, _path3, _path4, _path5, _path6, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIllustrationHello(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 183.352,
    height: 112,
    viewBox: "0 0 183.352 112",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:rgba(0,63,162,0.05);}.b{fill:#0081c6;}.c{fill:#001c85;}.d{fill:#003fa2;}.e{fill:#fff;}.f{fill:rgba(0,0,0,0);}.f,.g,.h{stroke:#003fa2;stroke-width:4px;}.f,.h{stroke-linecap:square;stroke-miterlimit:10;}.g{fill:#ccd1e7;}.h{fill:none;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M96.223,64.86H214.862l-64.712,112H31.51Z",
    transform: "translate(-31.51 -64.86)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M39.541,64.86H55.6l-8.031,13.9H31.51Z",
    transform: "translate(114.428 -32.042)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M34.394,64.86h5.768l-2.884,4.992H31.51Z",
    transform: "translate(138.522 -43.877)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M37.247,64.86H48.721l-5.737,9.93H31.51Z",
    transform: "translate(119.829 -48.841)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M36.89,64.86H47.65l-5.38,9.311H31.51Z",
    transform: "translate(-25.589 20.915)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M34.205,64.86H39.6l-2.7,4.664H31.51Z",
    transform: "translate(-22.527 9.562)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(118.022 79.086)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M45.377,64.86H73.111l-13.867,24H31.51Z",
    transform: "translate(-31.51 -64.86)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.801 6.442)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M21.629,4.87a.944.944,0,0,0-.205-.023H19.119V3.356A1.249,1.249,0,0,0,17.9,2a.136.136,0,0,0-.136.126,8.048,8.048,0,0,1-.4,2,3.284,3.284,0,0,1-.639.918A2.945,2.945,0,0,0,16,6.17.136.136,0,0,0,16,6.2V9.864a.136.136,0,0,0,.136.136H20.7a.944.944,0,0,0,.927-.743L22.35,6A.95.95,0,0,0,21.629,4.87Z",
    transform: "translate(-12.966 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 1.763,
    height: 4.61,
    rx: 0.881,
    transform: "translate(1 5.39)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(50.676 15)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 40,
    cy: 40,
    r: 40,
    transform: "translate(1 1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M8,15a14.545,14.545,0,0,0,29.091,0Z",
    transform: "translate(18.455 36.909)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "d",
    cx: 5.128,
    cy: 5.641,
    rx: 5.128,
    ry: 5.641,
    transform: "translate(19.462 29.718)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x2: 11.282,
    transform: "translate(48.179 33.821)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationHello);
export default __webpack_public_path__ + "static/media/Illustration_Hello.9fd65d374da9e7039065a7eda9faea1c.svg";
export { ForwardRef as ReactComponent };